import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  BhojanPackage,
  BhojanPackagePayload,
} from "@project/types/bhojan";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/bhojans`;
const SILENT: RequestConfig = { showNotification: false };

class BhojanService {
  listPage = (query: ListQuery = {}): Promise<PaginatedResult<BhojanPackage>> =>
    fetchListPage<BhojanPackage>(`${BASE}/`, query);

  get = async (id: number): Promise<BhojanPackage | undefined> => {
    const data = await get<ApiItemResponse<BhojanPackage> | BhojanPackage>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: BhojanPackagePayload): Promise<BhojanPackage> => {
    const data = await post<
      ApiItemResponse<BhojanPackage> | BhojanPackage,
      BhojanPackagePayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create bhojan package.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<BhojanPackagePayload>
  ): Promise<BhojanPackage | undefined> => {
    const data = await patch<
      ApiItemResponse<BhojanPackage> | BhojanPackage,
      Partial<BhojanPackagePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const bhojanService = new BhojanService();
